interface NamedLecturer {
    firstName: string;
    lastName: string;
}

const HEBREW_START = /^\s*[֐-׿]/;
const isHebrew = (s: string) => HEBREW_START.test(s);

function compareNames(a: string, b: string): number {
    const aHe = isHebrew(a);
    const bHe = isHebrew(b);
    if(aHe !== bHe) return aHe ? -1 : 1;
    return a.localeCompare(b, aHe ? 'he' : 'en', {sensitivity: 'base'});
}

export function compareLecturerName<T extends NamedLecturer>(a: T, b: T): number {
    return compareNames(a.lastName, b.lastName) || compareNames(a.firstName, b.firstName);
}

export function sortLecturers<T extends NamedLecturer>(lecturers: readonly T[]): T[] {
    return [...lecturers].sort(compareLecturerName);
}
